import Clipboard from 'clipboard';

class CopyLink {
  constructor() {
    let buttons = document.querySelectorAll('.copy-link--js');

    if (!!buttons) {
      this.init(buttons);
    }
  }

  init(nodes) {
    let cb = new Clipboard(nodes);

    cb.on('success', (event) => {
      const copyEvent = new CustomEvent('showTooltip', { detail: e.trigger.dataset.tooltipClickHtml });
      event.trigger.dispatchEvent(copyEvent);
    });

    cb.on('error', (event) => {
      const copyEvent = new CustomEvent('showTooltip', { detail: e.trigger.dataset.tooltipErrorHtml });
      event.trigger.dispatchEvent(copyEvent);
    });
  }
};

module.exports = CopyLink;
